import cx from 'classnames';
import React from 'react';

type ModalFooterProps = React.HTMLAttributes<HTMLDivElement>;

export const ModalFooter: React.FC<ModalFooterProps> = ({ className, ...bodyProps }) => <div className={cx('topdk-modal__footer', className)} {...bodyProps} />;

export default ModalFooter;
